<div class="app-container">
  <ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
  <section class="app-content">
    <router-outlet></router-outlet>
  </section>
</div>